const $body = $('body'),
    classModalVisible = 'modal--visible',
    classBodyModalVisible = 'show-modal';

import confetti from 'canvas-confetti';


// open modal action
$body.on('open-modal', '.modals .modal', function () {
    let $modal = $(this);

    if ($modal.hasClass('modal--mobile-only') && viewport().width > 767) {
        return false;
    }

    if (!$body.hasClass(classBodyModalVisible)) {
        $body.addClass(classBodyModalVisible);
    } else {
        // close modals that are already open
        $('.modal').not($modal).removeClass(classModalVisible);
        setTimeout(function () {
            $('.modal').not($modal).hide();
        }, 150);
    }

    $('.modals').stop().fadeIn(150, function () {
        $modal.show();

        setTimeout(function () {
            $modal.addClass(classModalVisible);
            $modal.find('.slick-slider').slick('resize'); // if modal contains slider, like the onboarding-tips on empty dashboard

            if ($modal.hasClass('modal--confetti')) {
                fireConfetti();
            }
        }, 100);
    });
});


// close modal action
$body.on('close-modal', '.modals .modal', function (event, vars) {
    let $modal = $(this);

    if (vars) {
        for (var key in vars) {
            $modal.html($modal.html().replace('|' + key + '|', vars[key]));
        }
    }

    if ($body.hasClass(classBodyModalVisible)) {
        $body.removeClass(classBodyModalVisible);
    }

    $modal.removeClass(classModalVisible);

    setTimeout(function () {
        $('.modals').stop().fadeOut(150, function () {
            $modal.hide();
        });
    }, 150);
});

$body.on('click', '.modals .modal .close-modal', function () {
    $(this).closest('.modal').trigger('close-modal');
});


// regular modal toggles
$('[data-toggle="modal"]').on('click', function (e) {
    e.preventDefault();

    const $modal = $('[data-modal-id="' + $(this).data('modal-id') + '"]');
    const vars = $(this).data('modal-vars');

    $modal.trigger('open-modal', vars);

});


// auto-show modals
$('.modal.modal--auto-show').each(function () {
    let $modal = $(this),
        delay = $(this).data('modal-delay');

    if (typeof delay === 'undefined') {
        delay = 0;
    }

    if ($modal.hasClass('modal--has-cookie')) {
        // check if modal has cookie

        let cookieHash = 'modal_'+ $modal.data('cookie-hash'), // based on modal content, so if content changes, modal will be shown again
            cookieDuration = $modal.data('cookie-duration');

        if (Cookies.get(cookieHash)) {
            // check if cookie exists - if so, dont show modal and remove from DOM completely
            $modal.remove();
        } else {
            // else, show modal and set cookie

            setTimeout(function () {
                $modal.trigger('open-modal');

                if (typeof cookieDuration !== 'undefined' && typeof cookieHash !== 'undefined') {
                    setCookie(cookieHash, 1, cookieDuration);
                }
            }, delay);
        }
    } else {
        // no cookie, show modal

        setTimeout(function () {
            $modal.trigger('open-modal');
        }, delay);
    }
});


$(document).on('click', function (e) {
    // close modals when clicking outside window
    if (!$(e.target).closest('.modal').length > 0) {
        $('.modals .modal.modal--visible').trigger('close-modal');
    }
});


//confetti stuff
let count = 300,
    defaults = {
        origin: { y: 0.5 },
        gravity: 0.75
    };

function fire(particleRatio, opts) {
    confetti(Object.assign({}, defaults, opts, {
        particleCount: Math.floor(count * particleRatio)
    }));
}

function fireConfetti() {
    fire(0.25, {
        spread: 26,
        startVelocity: 55,
    });
    fire(0.2, {
        spread: 60,
    });
    fire(0.35, {
        spread: 100,
        decay: 0.91,
        scalar: 0.8
    });
    fire(0.1, {
        spread: 120,
        startVelocity: 25,
        decay: 0.92,
        scalar: 1.2
    });
    fire(0.1, {
        spread: 120,
        startVelocity: 45,
    });
}
